import {
  ENQUEUE_SHEET,
  DEQUEUE_SHEET,
  DEQUEUE_ALL_SHEETS,
} from '../actionConstants';
import { SheetsState } from './sheetTypes';
import defaultState from './sheetDefaultState';

export default function (state: SheetsState = defaultState, action: any) {
  switch (action.type) {
    case ENQUEUE_SHEET:
      return {
        queue: [...state.queue, action.payload.sheet],
      };
    case DEQUEUE_SHEET:
      return {
        queue: state.queue.slice(0, -1),
      };
    case DEQUEUE_ALL_SHEETS:
      return {
        queue: [],
      };
    default:
      return state;
  }
}
